import { JsonLdResult } from 'src/templates/queries/types';

export const getSingle = <K extends string | number | boolean | undefined>(
  result: JsonLdResult[keyof JsonLdResult],
  key: string
): K | undefined => {
  if (Array.isArray(result)) {
    return getSingle(result[0], key);
  }
  switch (typeof result) {
    case 'object':
      return getSingle(result[key], key);
    case 'string':
      try {
        return (key === '@value' ? result : decodeURIComponent(result)) as K;
      } catch (error) {
        console.warn('decodeURIComponent failed for', { key, result }, error);
        return result as K;
      }
    default:
      return (result || undefined) as K;
  }
};

export const getMultiple = <K extends string | number | boolean | undefined>(
  result: JsonLdResult[keyof JsonLdResult],
  key: string
): K[] => {
  const results: K[] = [];
  const addValue = (val: JsonLdResult[keyof JsonLdResult]) => {
    const value = getSingle<K>(val, key);
    if (value !== undefined) {
      results.push(value);
    }
  };

  if (Array.isArray(result)) {
    result.forEach((res) => addValue(res));
  } else {
    addValue(result);
  }

  return results;
};
